/**
 * Import dependencies
 */

import React, {useRef, useEffect, useState} from "react";
import * as tf from "@tensorflow/tfjs";
// Import required model
// e.g. import * as tfmodel from "@tensorflow-models/tfmodel";
import * as cocoSsd from "@tensorflow-models/coco-ssd";
import Webcam from "react-webcam";
// import "./App.css";
// Import drawing utility
// e.g. import { drawRect } from "./utilities";
import {drawRect} from "./Utilities";
//import css
import "./CameraObjectDetectionCSS5IgnoreSaving.css"

const CameraObjectDetection5IgnoreSavings = ({inputNewItemUsingCamera}) => {

    const [isMounted, setIsMounted] = useState(true);
    let lastDetectionTime = 0;


    // Add this state at the top with other useState declarations
    const [detectionMessage, setDetectionMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'warning', 'info', 'error'


// Add this function to display messages without blocking
    const showMessage = (message, type = 'info', duration = 6000) => {
        console.log('Showing message:', message, 'Type:', type);  // Add this for debugging
        setMessageType(type);
        setDetectionMessage(message);

        // Auto-clear message after duration
        setTimeout(() => {
            setDetectionMessage('');
        }, duration);
    };



    const [deviceId, setDeviceId] = React.useState({});
    const [devices, setDevices] = React.useState([]);

    const handleDevices = React.useCallback(
        mediaDevices =>
            setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput")),
        [setDevices]
    );

    React.useEffect(
        () => {
            navigator.mediaDevices.enumerateDevices().then(handleDevices);
        },
        [handleDevices]
    );


    //implementation recognize objects

    const webcamRef = useRef(null);
    const canvasRef = useRef(null);

    const runCoco = async () => {
        const net = await cocoSsd.load();
        const interval = setInterval(() => {
            if (isMounted) {
                detect(net);
            }
        }, 500); // Odstęp 500ms, żeby nie przeciążać
        return () => clearInterval(interval); // Cleanup
    };

    useEffect(() => {
        const cleanup = runCoco();
        return () => {
            setIsMounted(false);
            cleanup?.then(clean => clean()); // Wywołaj cleanup
        };
    }, []); // Usuń [runCoco], żeby nie powodować ponownego ładowania


    const detect = async (net) => {
        if (!isMounted) return;

        const now = Date.now();
        if (now - lastDetectionTime < 500) return;
        lastDetectionTime = now;

        // Check data is available
        if (
            typeof webcamRef.current !== "undefined" &&
            webcamRef.current !== null &&
            webcamRef.current.video.readyState === 4
        ) {
            // Get Video Properties
            const video = webcamRef.current.video;
            const videoWidth = webcamRef.current.video.videoWidth;
            const videoHeight = webcamRef.current.video.videoHeight;

            // Set video width
            webcamRef.current.video.width = videoWidth;
            webcamRef.current.video.height = videoHeight;

            // Set canvas height and width
            canvasRef.current.width = videoWidth;
            canvasRef.current.height = videoHeight;

            // 4. Make Detections
            // e.g. const obj = await net.detect(video);
            const obj = await net.detect(video);

            // console.log(obj);
            // Draw mesh
            const ctx = canvasRef.current.getContext("2d");

            // cleaning tensors
            tf.dispose(obj);
            // 5. Update drawing utility
            // drawSomething(obj, ctx)
            drawRect(obj, ctx);

            // catch the recognised objects and send data to the Parent (ToDoListComponentsTrip)
            // It will add a just founded item to the input field and user can add an item to the list if he will press add button (+)
            // obj.forEach(
            //     predictions2 => {
            //         const text2 = predictions2['class'];
            //         if(text2 === 'person'){
            //             // console.log("person is skipped");
            //             // inputNewItemUsingCamera(text2);
            //         }
            //
            //         if (['orange', 'cup', 'hat', 'umbrella', 'shoe', 'eye glasses', 'handbag', 'tie', 'suitcase', 'skis',
            //             'snowboard', 'sports ball','bottle', 'plate', 'laptop', 'mouse', 'remote','keyboard', 'book',
            //              'hair drier'].indexOf(text2) >= 0) {
            //             // alert("Do you want to add a " + text2 + " to the bag?");
            //              inputNewItemUsingCamera(text2);
            //
            //          }
            //         if(text2 === "bicycle"||text2 === "bed") {
            //             alert("Cant pack a " + text2 + ". It is too big?");
            //             // inputNewItemUsingCamera(text2);
            //
            //         }
            //         if (['bird', 'cat', 'dog'].indexOf(text2) >= 0) {
            //             alert("Animals can not be packed?");
            //         }
            //
            //         if (['scissors', 'knife'].indexOf(text2) >= 0) {
            //             alert("Sharp object only to the main bag !!!");
            //         }
            //
            //     }
            // )
            obj.forEach(
                predictions2 => {
                    const text2 = predictions2['class'];
                    if(text2 === 'person'){
                        // Skip person
                    }

                    if (['orange', 'cup', 'hat', 'umbrella', 'shoe', 'eye glasses', 'handbag', 'tie', 'suitcase', 'skis',
                        'snowboard', 'sports ball','bottle', 'plate', 'laptop', 'mouse', 'remote','keyboard', 'book',
                        'hair drier',"cell phone"].indexOf(text2) >= 0) {
                        showMessage(`✓ ${text2} detected - Added to list, press + if you want take with you`, 'info', 7000);
                        // inputNewItemUsingCamera(text2);
                    }
                    if(text2 === "bicycle"||text2 === "bed"||text2 === "couch") {
                        showMessage(`✗ Can't pack a ${text2} - It's too big!`, 'warning', 6000);
                    }
                    if (['bird', 'cat', 'dog'].indexOf(text2) >= 0) {
                        showMessage(`✗ Animals cannot be packed!`, 'warning', 6000);
                    }

                    if (['scissors', 'knife'].indexOf(text2) >= 0) {
                        showMessage(`⚠ Sharp object - Main bag only!`, 'warning', 6000);
                    }
                    if (['clock'].indexOf(text2) >= 0) {
                        const text2 = "watch";
                        showMessage(`✓ ${text2} detected - Added to list, press + if you want take with you`, 'info', 7000);
                        // inputNewItemUsingCamera(text2);
                    }

                }
            )


        }
    };

    // useEffect(()=>{runCoco().then(r => {})},[runCoco]);



    //For testing only
    function addItemFromCamera(event)  {
        alert("Button was clicked");
        event.preventDefault();

    };


    const [windowSize, setWindowSize] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowSize(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobileView = windowSize < 768;
    const cameraSize = isMobileView ? 290 : 520;




    return (
        <div className="col s10 m8">
            <div id="cameraObjectDetection" className="row">


            {/*pick device*/}
            {/*<Webcam id="webcam" ref={webcamRef} audio={false} videoConstraints={{ deviceId }} />*/}

            {/*<canvas*/}
            {/*            ref={canvasRef}*/}
            {/*            style={{*/}
            {/*                position: "absolute",*/}
            {/*                marginLeft: "auto",*/}
            {/*                marginRight: "auto",*/}
            {/*                marginTop:"17%",*/}
            {/*                paddingBottom: "0%",*/}
            {/*                left: 0,*/}
            {/*                right: 0,*/}
            {/*                textAlign: "center",*/}
            {/*                zindex: 8,*/}
            {/*                width: "260px",*/}
            {/*                height: "260px",*/}
            {/*            }}>*/}
            {/*/>*/}
            {/*</canvas>*/}
                <Webcam
                    id="webcam"
                    ref={webcamRef}
                    audio={false}
                    videoConstraints={{ deviceId }}
                    style={{
                        width: '100%',
                        height: 'auto',
                        maxWidth: `${cameraSize}px`,
                        borderRadius: '8px'
                    }}
                />

                <canvas
                    ref={canvasRef}
                    style={{
                        position: "absolute",
                        marginLeft: "auto",
                        marginRight: "auto",
                        marginTop: isMobileView ? "1%" : "0%",
                        paddingBottom: isMobileView ? "10%" : "2%",
                        paddingTop: "8%",
                        left: 0,
                        right: 0,
                        textAlign: "center",
                        zindex: 7,
                        width: `${cameraSize}px`,
                        height: `${cameraSize}px`,
                    }}
                />

                {/*<div    id="cameraObjectDetectionButton">*/}
                {/*    {devices.map((device, key) => (*/}
                {/*        <button*/}
                {/*            id="buttonSizeCamera"*/}
                {/*            key={device.deviceId}*/}
                {/*            onClick={() => setDeviceId(device.deviceId)}*/}
                {/*        >*/}
                {/*            {device.label || `Device ${key + 1}`}*/}
                {/*        </button>*/}
                {/*    ))}*/}
                {/*</div>*/}

                <div    id="cameraObjectDetectionButton">
                    {devices.slice(0, 2).map((device, key) => (
                        <button
                            id="buttonSizeCamera"
                            key={device.deviceId}
                            onClick={() => setDeviceId(device.deviceId)}
                        >
                            {device.label || `Camera ${key + 1}`}
                        </button>
                    ))}
                </div>


            </div>


            {detectionMessage && (
                <div
                    style={{
                        position: "absolute",
                        top: isMobileView ? "40%" : "60%",
                        right: isMobileView ? "15%" : "40%",
                        padding: "5px 5px",
                        borderRadius: "5px",
                        backgroundColor: messageType === 'warning' ? '#ff9800' :
                            messageType === 'error' ? '#f44336' : '#4caf50',
                        color: 'white',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        zIndex: 9000,
                        maxWidth: '300px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        animation: 'slideIn 0.3s ease-in-out'
                    }}    >
                    {detectionMessage}
                </div>
            )}




        </div>
    )//end return

}

export default CameraObjectDetection5IgnoreSavings;

